module.exports = __webpack_public_path__ + "img/icon7.1c803c5d.svg";